<template>
  <div class="route-operator-map">
    <v-card class="mb-4" elevation="2">
      <v-card-title class="d-flex align-center">
        <v-icon color="primary" class="mr-3">mdi-map-marker-path</v-icon>
        <span class="text-h6">Mi Ruta Especifica</span>
        <v-spacer />
        <v-chip color="grey" variant="tonal">No disponible</v-chip>
      </v-card-title>

      <v-card-text>
        <v-alert type="info" variant="tonal" class="mb-4">
          <template #title>Mapa no disponible</template>
          Esta vista queda deshabilitada hasta contar con una fuente backend real y self-scoped para ruta,
          puntos de venta, incidencias y geometria. No se muestran datos inventados ni ubicaciones simuladas.
        </v-alert>

        <v-row>
          <v-col cols="12" md="4">
            <v-card variant="tonal" color="primary" class="status-card">
              <v-card-text>
                <v-icon color="primary" class="mr-2">mdi-routes</v-icon>
                Ruta: sin fuente real disponible
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card variant="tonal" color="success" class="status-card">
              <v-card-text>
                <v-icon color="success" class="mr-2">mdi-store</v-icon>
                POS: no cargados en runtime
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card variant="tonal" color="warning" class="status-card">
              <v-card-text>
                <v-icon color="warning" class="mr-2">mdi-alert-circle</v-icon>
                Incidencias: usar modulo de incidencias real
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script setup lang="ts">
// B1I: vista honestificada. No inicializa Leaflet, no carga POS/rutas/incidencias
// ficticias y no expone acciones operativas sin backend real self-scoped.
</script>

<style scoped>
.route-operator-map {
  padding: 16px;
}

.status-card {
  border-radius: 8px;
}
</style>
